"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigQuerySqlGenerator = void 0;
const base_1 = require("./base");
class BigQuerySqlGenerator extends base_1.BaseSqlGenerator {
    quoteIdentifier(name) {
        return `\`${name.replace(/`/g, '\\`')}\``;
    }
    generateStringLiteral(node) {
        // BigQuery treats ''' as a triple-quoted string opener,
        // so we must use backslash escaping instead of doubling quotes
        const escaped = node.value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
        return `'${escaped}'`;
    }
    generateModulo(left, right) {
        // BigQuery MOD requires matching numeric types
        return `MOD(CAST(${left} AS NUMERIC), CAST(${right} AS NUMERIC))`;
    }
}
exports.BigQuerySqlGenerator = BigQuerySqlGenerator;
//# sourceMappingURL=bigquery.js.map